// Task contacts in the agent UI (Tasks Phase 1, 2026-10-13): a due task
// delivered to the Queue on the 'task' channel. Pure helpers, so node --test
// covers them.
//
// The response follows the order's client (the server's taskResponse on
// GET /api/conversations/:id): an email for a Website order, sent from the
// brand's service@ address (2026-10-13) through the reply box; an eBay
// message for an eBay order, sent from its step; nothing for Amazon or an
// unrouted task. No pre-send gate here: service@ is live, and an account
// whose outbound mode is off is refused by the send path with its usual
// message.

export function isTaskContact(conversation) {
  return conversation?.channel === 'task'
}

// The channel the reply box should behave as: email for an email response,
// eBay for an eBay one, the task channel itself otherwise (no reply box).
export function taskPanelChannel(conversation) {
  const kind = conversation?.taskResponse?.kind ?? null
  if (kind === 'email') return 'm365_email'
  if (kind === 'ebay') return 'ebay'
  return 'task'
}

// What SuggestionPanel needs for a task contact, or null for any other
// contact: no reply box unless the response is an email.
export function taskPanelProps(conversation) {
  if (!isTaskContact(conversation)) return null
  const response = conversation.taskResponse ?? {}
  return {
    isTask: true,
    noDraftBox: response.kind !== 'email',
    sendBlockedReason: null,
    fromAddress: response.kind === 'email' ? (response.fromAddress ?? null) : null,
  }
}

// "T1001", from the contact's own metadata.
export function taskIdLabel(taskId) {
  return taskId == null ? '' : `T${taskId}`
}

// The list label for a task contact: "Task T1001".
export function taskContactLabel(conversation) {
  const id = conversation?.metadata?.taskId ?? null
  return id == null ? 'Task' : `Task ${taskIdLabel(id)}`
}

// A message that is the task itself (the contact's one inbound turn), shown
// as the Task card instead of a bubble.
export function isTaskMessage(message) {
  return message?.metadata?.messageKind === 'task'
}

// A contact that answers a task's email (metadata.replyToTask, set at ingest
// from In-Reply-To / References): { taskId, conversationId } or null.
export function replyToTask(conversation) {
  const link = conversation?.metadata?.replyToTask
  return link?.taskId != null && link?.conversationId ? link : null
}

// The Queue / Closed channel filter (2026-10-13): Tasks is an option, and in
// the default selection, only for someone who may use Tasks.
export function channelOptionsFor(knownChannels, me) {
  return mayUseTasks(me) ? knownChannels : knownChannels.filter((c) => c !== 'task')
}
export function defaultChannelFilterFor(baseDefault, me) {
  return mayUseTasks(me) && !baseDefault.includes('task') ? [...baseDefault, 'task'] : baseDefault.filter((c) => c !== 'task' || mayUseTasks(me))
}
function mayUseTasks(me) {
  return Boolean(me?.tasksEnabled && me?.canUseTasks)
}
